export const customEventSeparator = '_lxlxl_';
